import { h } from 'preact';
import { Component, PropTypes, Children } from 'react';

class App extends Component {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired,
        i18n: PropTypes.object.isRequired
    }

    static childContextTypes = {
        theme: PropTypes.object.isRequired,
        i18n: PropTypes.object.isRequired,
        bus: PropTypes.object.isRequired
    }

    getChildContext () {
        const { theme, i18n, app } = this.props;
        return { theme, i18n, bus: app.bus };
    }

    render ({ theme }) {
        return (
            <div className={ theme.widgetContainer }>
                { Children.only(this.props.children) }
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/index.js